import { BodyBasedExpression } from '../Expression.js';
export class DivExpression extends BodyBasedExpression {
    evaluate(visitor, localVariables) {
        const { source, body } = this._evaluateBodyAndSource(visitor, localVariables);
        return Math.floor(source / body);
    }
}
//# sourceMappingURL=DivExpression.js.map